import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cefgzfyh: FaireBrandEntity = {
  token: "b_cefgzfyh",
  type: "brand",
  name: "Jack Be Nimble Candles",
  avatarUrl:
    "https://cdn.faire.com/fastly/38c613ccdf4ec026927607281d7aa36f9d0be9febb7e02fc351b9892d810b995.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d68bb067a5fafdbfa09a76c5cede4b3d17f8da3bf57de6d595e1e5f0ffb38bf.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/38c613ccdf4ec026927607281d7aa36f9d0be9febb7e02fc351b9892d810b995.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d68bb067a5fafdbfa09a76c5cede4b3d17f8da3bf57de6d595e1e5f0ffb38bf.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 99,
  isInsider: true,
  description:
    '"I started making candles because I would purchase expensive retail candles which smelled great in the store but would lose their smell after a couple of burns.  I knew there had to be a better way…" - Paul Bruschi, Founder\n\nJack Be Nimble is a candle and home fragrance company based in Atlanta, GA, and founded in 2010 by Paul Bruschi. \nPaul is a former professional ballet dancer and the Jack Be Nimble name was inspired by a coloring book of “JACK” jumping over a candlestick. For him, it brought together his two passions... ballet and candles! \nWe hand-pour each of our candles in batches of twelve in our studio in Atlanta. All of our candles are made using American-grown soy wax, all-natural cotton wicks, and fine fragrance oils. Our products are inspired by modern design and family gatherings that enhance your environment and create future memories. We pride ourselves on meticulous craftsmanship, ethical production, and accessible prices. All of our products are vegan, cruelty-free, and phthalate-free.  As part of that mission, we are devoted to creating a superior product that you will be proud to use in your home every day. ',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:31.457Z",
    importedBy: "entity-db-cli",
  },
};
